import React from "react";
import { API } from "./api";

const ContentContext = React.createContext({ content: null, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = React.useState(null);

  const refresh = React.useCallback(() => {
    fetch(`${API}/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => data && setContent(data))
      .catch(() => {});
  }, []);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  return <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return React.useContext(ContentContext);
}
